// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: false,
  googleMapsApi: 'AIzaSyAOe84NlarMJP2GIb8ls1BzKcFdqtrHhsc',
  recaptchaSiteKey: '6LfdqsIUAAAAANQQdwW1990MplboV_a75etKpeYt',
  recaptchaSecret: '6LfdqsIUAAAAAHQ1SviUXehXkI9cvVWCT9jsg3Wl',
  appURL: 'https://app-gigexchange-nz.web.app',
  functionsURL: 'https://us-central1-gigexchange-nz.cloudfunctions.net',
  mediaURL: 'https://cdn.gigexchange.com',
  supportURL: 'https://support-gigexchange-nz.web.app',
  webURL: 'https://gigexchange-nz.web.app',
  stripePublishableKey:'pk_test_Wp2L26LDMidJt0mRXMMp3Lr7',
  webClientID: '676259069991-2jkp03mc4n2amq47h4oqvok4artmakf0.apps.googleusercontent.com',
  firebase: {
    apiKey: "AIzaSyB6bWYlWgkSXLIAbTqrlhOM2SL58salLl8",
    authDomain: "gigexchange-nz.firebaseapp.com",
    databaseURL: "https://gigexchange-nz.firebaseio.com",
    projectId: "gigexchange-nz",
    storageBucket: "gigexchange-nz.appspot.com",
    bucketURL: "https://firebasestorage.googleapis.com/v0/b/gigexchange-nz.appspot.com/o/",
    messagingSenderId: "676259069991",
    appId: "1:676259069991:web:4fe4b56cbd6a3161284e02",
    measurementId: "G-M2X49PNG94"
  }
};
